// extracted by mini-css-extract-plugin
export default {"dateLabel":"CustomSingleDatePicker_dateLabel__OlYJx"};